import { Outlet, Navigate, useLocation } from "react-router-dom";
import Loader from "../../core/components/shared/Loader/Loader";
import { t } from "i18next";
import APP_CONST from "../../core/shared/constants";

const PrivateRoutes = ({
  isLoaded,
  roleList,
  roleGroup,
  hasSubMenuProtection = false,
  isSubMenuLoaded = false,
  subMenuList = [],
  sidepanelToggle,
}) => {
  const location = useLocation();
  let currentPathName = location.pathname;
  if (
    (!isLoaded && !hasSubMenuProtection) ||
    (hasSubMenuProtection && (!isLoaded || !isSubMenuLoaded))
  ) {
    return <Loader width={!sidepanelToggle ? "100%" : ""} />;
  } else if (
    (isLoaded && roleList.includes(roleGroup) && !hasSubMenuProtection) ||
    (isLoaded &&
      roleList.includes(roleGroup) &&
      hasSubMenuProtection &&
      isSubMenuLoaded &&
      subMenuList.includes(currentPathName))
  ) {
    return <Outlet />;
  } else {
    return (
      <Navigate
        to={getRedirectLink(roleList, roleGroup, currentPathName, subMenuList)}
        replace
      />
    );
  }
};

const getRedirectLink = (roleList, roleGroup, currentPathName, subMenuList=[]) => {
  let redirectLink = "/"; // This will be Trail Master File -> Overview page
  let archivePageChecksForAvailablePagePermissionToRedirect =
    roleGroup === t("ADMIN.TEXT_ARCHIVE") &&
    !roleList.includes(t("ADMIN.TEXT_TMF")) &&
    roleList.includes(t("ADMIN.TEXT_TMFADMIN"));
  let trailMasterFilePageChecksForAvailablePagePermissionToRredirect =
    roleGroup === t("ADMIN.TEXT_TMF") &&
    !roleList.includes(t("ADMIN.TEXT_TMF")) &&
    roleList.includes(t("ADMIN.TEXT_TMFADMIN"));
  if(roleList.length === 1 && roleList.includes(t("ADMIN.TEXT_ARCHIVE"))){
      redirectLink = subMenuList?.includes(APP_CONST.SIDEPANEL_ROUTE.EMS_REPO) ? APP_CONST.SIDEPANEL_ROUTE.EMS_REPO : APP_CONST.SIDEPANEL_ROUTE.ARCHIVAL
  } else {
  if (
    archivePageChecksForAvailablePagePermissionToRedirect ||
    trailMasterFilePageChecksForAvailablePagePermissionToRredirect
  ) {
    redirectLink = "/tmf-structure"; // This will be TMF Admin -> TMF Structure page
  } else if (
    currentPathName === "/drop-zone" &&
    roleGroup === t("ADMIN.TEXT_TMF") &&
    roleList.includes(t("ADMIN.TEXT_TMF"))
  ) {
    redirectLink = "/zone-section";
  }
  }
  return redirectLink;
};

export default PrivateRoutes;
